import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { AddressComponent } from 'premier-capability-policyjob-react';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './PropertyDetailsComponent.metadata.json5';

function PropertyDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyDetailsComponent');
    const [isEditAddress, setIsEditAddress] = useState(false)
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const [actAddress, setActAddress] = useState(null)

    if (_.isUndefined(modelVM.accountLocFie.value)) {
        const model = { country: 'CA' }
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            if (value === 'SeaConwitShoTerRen' && changedPath === 'occFie') {
                _.set(modelVM.value, 'isthilocoffshoterrrenFie', true);
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [modelVM.value, pathUpdated, submissionVM, updateWizardData]
    );

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);


    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountLocFie;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        setIsEditAddress(false)
    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {

            modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        occOthExpFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'OthCom'
        },
        datdwebecvacFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'VacCon'
        },
        curStaFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'VacCon'
        },
        ifothpleexpFie: {
            visible: _.get(modelVM, 'curStaFie.value.code') === 'Other'
        },
        istheprobeimaiinuswinFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'OthCom'
        },
        istheproviefrotherroaFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'OthCom'
        },
        istheproonpavroaFie: {
            visible: _.get(modelVM, 'occFie.value.code') === 'OthCom'
        },
        isthilocoffshoterrrenFie: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined &&
                _.get(modelVM, 'occFie.value.code') !== 'OthCom' && _.get(modelVM, 'occFie.value.code') !== 'VacCon'
        },
        numofmonoccbyinsasresFie: {
            visible: ['OwnOccCon', 'RenCon', 'SeaCon', 'SeaConwitShoTerRen', 'StuRenCon' ].includes(_.get(modelVM, 'occFie.value.code'))
        },
        expReaFie: {
            visible: _.get(modelVM, 'doanybuspurtakplaopreFie.value', false)
        },
        expRea2Fie: {
            visible: _.get(modelVM, 'istheuniatttoanycoexpFie.value', false)
        },
        ifappismotwatormotrenFie: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined &&
                _.get(modelVM, 'occFie.value.code') !== 'OthCom' && _.get(modelVM, 'occFie.value.code') !== 'VacCon'
        },
        maintenceHeader: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined && _.get(modelVM, 'occFie.value.code') !== 'SeaConwitShoTerRen'
                && _.get(modelVM, 'occFie.value.code') !== 'OwnOccCon' && _.get(modelVM, 'occFie.value.code') !== 'SeaCon'
        },
        howoftistheprovisFie: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined && _.get(modelVM, 'occFie.value.code') !== 'SeaConwitShoTerRen'
                && _.get(modelVM, 'occFie.value.code') !== 'OwnOccCon' && _.get(modelVM, 'occFie.value.code') !== 'SeaCon'
        },
        namofperresforthecproFie: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined && _.get(modelVM, 'occFie.value.code') !== 'SeaConwitShoTerRen'
                && _.get(modelVM, 'occFie.value.code') !== 'OwnOccCon' && _.get(modelVM, 'occFie.value.code') !== 'SeaCon'
        },
        whatherelofthepermproFie: {
            visible: _.get(modelVM, 'occFie.value.code') !== undefined && _.get(modelVM, 'occFie.value.code') !== 'SeaConwitShoTerRen'
                && _.get(modelVM, 'occFie.value.code') !== 'OwnOccCon' && _.get(modelVM, 'occFie.value.code') !== 'SeaCon'
        },
        desrendetFie: {
            visible: _.get(modelVM, 'wilthebeanyrenFie.value', false)
        },
        renbudFie: {
            visible: _.get(modelVM, 'wilthebeanyrenFie.value', false)
        },
        wilthebeanystrrenFie: {
            visible: _.get(modelVM, 'wilthebeanyrenFie.value', false)
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            AddressComponent
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyDetailsComponent.propTypes = wizardProps;
export default withRouter(PropertyDetailsComponent);
